module.exports = __webpack_public_path__ + "static/HKGrotesk-Medium-296bfb9b8b1a36d07e1830eac65730f1.woff";